import Inputmask from 'inputmask';

const selectTools = {
    init() {
        this.setupEventListeners();
    },

    setupEventListeners() {
        $(document).on('click', '.js__moto_list_item', this.onMotoListItemClick.bind(this));
        $(document).on('click', '.js__drop_moto_list', this.onDropMotoListClick.bind(this));
        $(document).on('click', '.js__branch_code_item', this.onBranchCodeItemClick.bind(this));
        $(document).on('click', '.js__drop_branch_code', this.onDropBranchCodeClick.bind(this));
        $(document).on('click', '.js__model_goods_item', this.onModelGoodsItemClick.bind(this));
        $(document).on('click', '.js__drop_model_goods', this.onDropModelGoodsClick.bind(this));
        $(document).on('click', '.js__model_units_item', this.onModelUnitsItemClick.bind(this));
        $(document).on('click', '.js__drop_model_units', this.onDropModelUnitsClick.bind(this));
        $(document).on('click', '.js__custom_item', this.onCustomItemClick.bind(this));
        $(document).on('click', '.js__drop_custom', this.onDropCustomClick.bind(this));
        $(document).on('input', '.js__search_select_list', this.onSearchInputChange.bind(this));
    },

    onMotoListItemClick(event) {
        const item = $(event.currentTarget);
        const parentBlock = $('.js__moto_list_select');
        const btn = parentBlock.find('.js__drop_moto_list');
        const list = parentBlock.find('.js__moto_list_list');
        const model_name = [];

        item.toggleClass('active');

        list.find('.js__item.active').each(function () {
            const itemActive = $(this);
            model_name.push(itemActive.attr('data-model_name'));
        })

        btn.find('.js__name').empty().text(model_name.join(', '));

        parentBlock.find('input.js__model_name').val(JSON.stringify(model_name));
    },

    onDropMotoListClick(event) {
        const dropLeaveFeedback = $(event.currentTarget);
        dropLeaveFeedback.toggleClass('active');
        const wrapper = dropLeaveFeedback.closest('.js__moto_list_select');
        wrapper.find('.js__drop_body_moto_list').slideToggle();
        wrapper.toggleClass('open');
    },

    onBranchCodeItemClick(event) {
        const item = $(event.currentTarget);
        const parentBlock = $('.js__branch_code_select');
        const btn = parentBlock.find('.js__drop_branch_code');
        const name = item.attr('data-name');

        btn.find('.js__name').empty().text(name);

        const branchCode = item.attr('data-branch_code');
        const dealerName = item.attr('data-dealer_name');

        parentBlock.find('input.js__branch_code').val(branchCode);
        parentBlock.find('input.js__dealer_name').val(dealerName);
        parentBlock.find('.js__item.active').removeClass('active');
        item.addClass('active');
        this.closeSelect('.js__drop_branch_code', '.js__branch_code_select');
    },

    onDropBranchCodeClick(event) {
        const dropLeaveFeedback = $(event.currentTarget);
        dropLeaveFeedback.toggleClass('active');
        const wrapper = dropLeaveFeedback.closest('.js__branch_code_select');
        wrapper.find('.js__drop_body_branch_code').slideToggle();
        wrapper.toggleClass('open');
    },

    onModelGoodsItemClick(event) {
        const item = $(event.currentTarget);
        const parentBlock = $('.js__model_goods_select');
        const btn = parentBlock.find('.js__drop_model_goods');
        const name = item.attr('data-name');

        btn.find('.js__name').empty().text(name);

        const goodId = item.attr('data-good_id');
        const goodName = item.attr('data-good_name');

        parentBlock.find('input.js__good_id').val(goodId);
        parentBlock.find('input.js__good_name').val(goodName);
        parentBlock.find('.js__item.active').removeClass('active');
        item.addClass('active');
        this.closeSelect('.js__drop_model_goods', '.js__model_goods_select');
    },

    onDropModelGoodsClick(event) {
        const dropLeaveFeedback = $(event.currentTarget);
        dropLeaveFeedback.toggleClass('active');
        const wrapper = dropLeaveFeedback.closest('.js__model_goods_select');
        wrapper.find('.js__drop_body_model_goods').slideToggle();
        wrapper.toggleClass('open');
    },

    onModelUnitsItemClick(event) {
        const item = $(event.currentTarget);
        const parentBlock = $('.js__model_units_select');
        const btn = parentBlock.find('.js__drop_model_units');
        const name = item.attr('data-name');

        btn.find('.js__name').empty().text(name);

        const unitId = item.attr('data-unit_id');
        const unitName = item.attr('data-unit_name');
        const modelId = item.attr('data-model_id');

        parentBlock.find('input.js__unit_id').val(unitId);
        parentBlock.find('input.js__unit_name').val(unitName);
        parentBlock.find('input.js__model_id').val(modelId);
        parentBlock.find('.js__item.active').removeClass('active');
        item.addClass('active');
        this.closeSelect('.js__drop_model_units', '.js__model_units_select');
    },

    onDropModelUnitsClick(event) {
        const dropLeaveFeedback = $(event.currentTarget);
        dropLeaveFeedback.toggleClass('active');
        const wrapper = dropLeaveFeedback.closest('.js__model_units_select');
        wrapper.find('.js__drop_body_model_units').slideToggle();
        wrapper.toggleClass('open');
    },

    onCustomItemClick(event) {
        const item = $(event.currentTarget);
        const parentBlock = item.closest('.js__custom_select');
        const btn = parentBlock.find('.js__drop_custom');
        const name = item.attr('data-name');

        btn.find('.js__name').empty().text(name);

        const inputNmae = item.attr('data-input_name');

        parentBlock.find(`input.js__custom_input[name=${inputNmae}]`).val(name);
        parentBlock.find('.js__item.active').removeClass('active');
        item.addClass('active');
        this.closeSelect('.js__drop_custom', '.js__custom_select');
    },

    onDropCustomClick(event) {
        const dropLeaveFeedback = $(event.currentTarget);
        dropLeaveFeedback.toggleClass('active');
        const wrapper = dropLeaveFeedback.closest('.js__custom_select');
        wrapper.find('.js__drop_body_custom').slideToggle();
        wrapper.toggleClass('open');
    },

    onSearchInputChange(event) {
        const filter = $(event.currentTarget).val().trim().toLowerCase();
        const phoneListItems = $(event.currentTarget).closest('.js__body_search').find('.js__item');
        let type = typeof $(event.currentTarget).attr('data-type') ? $(event.currentTarget).attr('data-type') : '';

        phoneListItems.each(function () {
            const iso = $(this).attr('data-iso') ? $(this).attr('data-iso').trim().toLowerCase() : null;
            const name = $(this).attr('data-name') ? $(this).attr('data-name').trim().toLowerCase() : null;
            const code = $(this).attr('data-code') ? $(this).attr('data-code').trim().toString() : null;
            if ((iso && iso.includes(filter)) || (name && name.includes(filter)) || (code && code.includes(filter))) {
                $(this).show();
                $(this).removeClass('hide_block');
            } else {
                $(this).hide();
                $(this).addClass('hide_block');
            }
        });
        if (filter == "") {
            phoneListItems.show();
            phoneListItems.removeClass('hide_block');
        }

        const wrappersMulti = $(event.currentTarget).closest('.js__body_search').find('.js__item_parent');

        wrappersMulti.each(function () {
            const startCount = $(this).attr('data-items');
            const endCount = $(this).find('.js__item.hide_block').length;

            if (startCount == endCount) {
                $(this).hide();
            } else {
                $(this).show();
            }
        })
    },

    closeSelect(selector, wrapper) {
        const dropSelect = $(selector);
        dropSelect.removeClass('active');
        const wrapperNode = dropSelect.closest(wrapper);
        wrapperNode.find('.js__body_search').slideUp();
        wrapperNode.removeClass('open');
    },
};

$(window).on('load', function () {
    selectTools.init();

    $(window).on('click', function (event) {
        if (!$(event.target).closest('.js__branch_code_select, .js__model_goods_select, .js__moto_list_select, .js__model_units_select, .js__custom_select').length) {
            selectTools.closeSelect('.js__drop_branch_code', '.js__branch_code_select');
            selectTools.closeSelect('.js__drop_model_goods', '.js__model_goods_select');
            selectTools.closeSelect('.js__drop_model_units', '.js__model_units_select');
            selectTools.closeSelect('.js__drop_custom', '.js__custom_select');
            selectTools.closeSelect('.js__drop_moto_list', '.js__moto_list_select');
        }
    });
});